import {Base} from "@/api/Base"

export class SalaryDelete extends Base {
    path = "salary/delete"
}